import { render, staticRenderFns } from "./shopSizeList.vue?vue&type=template&id=780516df&scoped=true"
import script from "./shopSizeList.vue?vue&type=script&lang=js"
export * from "./shopSizeList.vue?vue&type=script&lang=js"
import style0 from "./shopSizeList.vue?vue&type=style&index=0&id=780516df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780516df",
  null
  
)

export default component.exports